import {Component, Input} from '@angular/core';

@Component({
  selector: 'nc-splash-screen',
  templateUrl: './nc-splash-screen.component.html',
  styleUrls: ['./nc-splash-screen.component.scss']
})
export class NcSplashScreenComponent {
  @Input() image: string;
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';
  @Input() mode: 'indeterminate' | 'buffer' | 'query' = 'indeterminate';
}
